<app-dialog [disableClose]="true" [width]="661">
  <ng-template #bodyContent>
    <div class="cancel-order-dialog-wrapper" id="cancel-order-dialog-wrapper">
      <div>
        @switch (cancelDisplayType) { @case (orderDisplayType.SingleFolderSelection) {
        <ng-container *ngTemplateOutlet="singleFolderSelection"></ng-container>
        } @case (orderDisplayType.OrderSelection) {
        <ng-container *ngTemplateOutlet="orderSelection"></ng-container>
        } @case (orderDisplayType.MultipleFolderSelection) {
        <ng-container *ngTemplateOutlet="multipleFolderSelection"></ng-container>
        } @case (orderDisplayType.SingleSeatSelection) {
        <ng-container *ngTemplateOutlet="singleSeatSelection"></ng-container>
        } @case (orderDisplayType.MultipleSeatSelection) {
        <ng-container *ngTemplateOutlet="multipleSeatSelection"></ng-container>
        } @case (orderDisplayType.MultipleSubscriptionSelection) {
        <ng-container *ngTemplateOutlet="subscriptionRefundSelection"></ng-container>
        } @case (orderDisplayType.SubscriptionSeatsSelection) {
        <ng-container *ngTemplateOutlet="subscriptionSeatsRefundSelection"></ng-container>
        } }
      </div>
    </div>
  </ng-template>
  <ng-template #actionsContent>
    <div class="orders-cancel-actions">
      <div class="orders-folder-cancel-actions">
        <button
          tabindex="-1"
          mat-button
          mat-dialog-close
          (click)="closeAndLeaveCancel()"
          class="tick-btn tick-btn-secondary me-2"
          data-cy="undo-btn"
        >
          {{ (isSubscriptionRefund ? 'orders.abortRefund' : 'orders.abortUndo') | translate }}
        </button>
        <button
          mat-button
          (click)="processOrderCancel()"
          [disabled]="disabledCancelButton()"
          class="tick-btn tick-btn-primary"
          data-cy="validate-folder-btn"
        >
          {{ validationBtnLabel | translate }}
        </button>
      </div>
    </div>
  </ng-template>
</app-dialog>
<ng-template #defaultInfoLabel let-value="value">
  <div class="orders-folder-payment-label">{{ value }}</div>
</ng-template>

<ng-template #singleFolderSelection let-value="value">
  <div class="single-folder-selection">
    <div class="cancel-order-header">
      <h4>{{ 'orders.CancellationOfFolderNumber' | translate }} {{ cancelFolders?.[0]?.id }}</h4>
      <div class="ms-2 label">{{ 'orders.orderNumber' | translate }} {{ cancelFolders?.[0]?.orderId }}</div>
    </div>
    <div class="cancel-order-content">
      <ng-container *ngTemplateOutlet="refundCustomer"></ng-container>
      <ng-container *ngTemplateOutlet="paymentModeForSingle"></ng-container>
      <ng-container *ngTemplateOutlet="cancelOrderFooter"></ng-container>
    </div>
  </div>
</ng-template>
<ng-template #orderSelection let-value="value">
  <div class="order-selection">
    <div class="cancel-order-header">
      <h4>{{ 'orders.cancellationOfOrderNumber' | translate }} {{ cancelFolders?.[0]?.orderId }}</h4>
      <ng-container *ngTemplateOutlet="headerTooltip"></ng-container>
    </div>
    <div class="cancel-order-content">
      @if(isSinglePayment) {
      <div>
        <ng-container *ngTemplateOutlet="refundCustomer"></ng-container>
        <ng-container *ngTemplateOutlet="paymentModeForSingle"></ng-container>
      </div>
      }@else {
      <div>
        <ng-container *ngTemplateOutlet="paymentModeForMultiple"></ng-container>
        <ng-container *ngTemplateOutlet="ordersSummaryList"></ng-container>
      </div>
      }
      <ng-container *ngTemplateOutlet="cancelOrderFooter"></ng-container>
    </div>
  </div>
</ng-template>
<ng-template #multipleFolderSelection let-value="value">
  <div class="multiple-folder-selection">
    <div class="cancel-order-header">
      <h4>{{ 'orders.CancellationOfSelection' | translate }}</h4>
      <ng-container *ngTemplateOutlet="headerTooltip"></ng-container>
    </div>
    <div class="cancel-order-content">
      <ng-container *ngTemplateOutlet="paymentModeForMultiple"></ng-container>
      <ng-container *ngTemplateOutlet="ordersSummaryList"></ng-container>
    </div>
    <ng-container *ngTemplateOutlet="cancelOrderFooter"></ng-container>
  </div>
</ng-template>
<ng-template #singleSeatSelection let-value="value">
  <div class="single-seat-selection">
    <div class="cancel-order-header">
      @if(isProduct(cancelseats)) {
      <h4>{{ 'orders.CancellationOfProduct' | translate }}</h4>
      }@else {
      <h4>
        {{ 'orders.CancellationOfSeat' | translate }} {{ cancelseats?.[0]?.seatInfos?.accessCode }}
        {{ cancelseats?.[0]?.seatInfos?.rank}} {{ cancelseats?.[0]?.seatInfos?.seatNumber}}
      </h4>
      }
      <div class="ms-2 label">{{ 'orders.folderNumber' | translate }} {{ cancelseats?.[0]?.orderItemId}}</div>
    </div>
  </div>
  <div class="cancel-order-content">
    <ng-container *ngTemplateOutlet="seatRefundCustomer"></ng-container>
    <ng-container *ngTemplateOutlet="paymentModeForSingleEdit"></ng-container>
  </div>
  <ng-container *ngTemplateOutlet="cancelOrderFooter"></ng-container>
</ng-template>
<ng-template #multipleSeatSelection let-value="value">
  <div class="multiple-seat-selection">
    <div class="cancel-order-header">
      <h4>{{ 'orders.CancellationOfSelection' | translate }}</h4>
    </div>
    <div class="cancel-order-content">
      <ng-container *ngTemplateOutlet="seatsSummaryList"></ng-container>
      <ng-container *ngTemplateOutlet="seatRefundCustomer"></ng-container>
      <ng-container *ngTemplateOutlet="paymentModeForSingleEdit"></ng-container>
    </div>
    <ng-container *ngTemplateOutlet="cancelOrderFooter"></ng-container>
  </div>
</ng-template>
<!--
  Remboursement de PLACES d'une formule, sur toutes ses seances. Jumeau de
  #subscriptionRefundSelection, a deux details pres : le recapitulatif liste les PLACES selectionnees
  (`cancelseats`) et non les seances, et le montant vient du preflight de la commande — sur un
  abonnement le prix est porte par la formule, les places affichees valent 0 EUR.
-->
<ng-template #subscriptionSeatsRefundSelection let-value="value">
  <div class="subscription-refund-selection">
    <div class="cancel-order-header">
      <h4>{{ 'orders.refundOfFormulaSeats' | translate }}</h4>
      <div class="ms-2 label">{{ 'orders.orderNumber' | translate }} {{ orderId }}</div>
    </div>
    <div class="cancel-order-content">
      <ng-container *ngTemplateOutlet="seatRefundCustomer"></ng-container>
      <div class="cancel-order-refund">
        <div class="cancel-folder-refund-header">
          <h5>{{ 'orders.refundMethod' | translate }}</h5>
        </div>
        <div class="cancel-folder-payment-value-inprogress" id="cancel-subscription-seats-payment">
          <app-payment-mode-form
            appendTo="body"
            [formGroup]="form"
            [modes]="paymentModes$ | async"
            [hiddenPaymentTypes]="true"
            [paymentTypes]="paymentTypes"
            [totalAmount]="totalAmount$ | async"
            [clearDefautSelection]="isSubscriptionRefund"
            (amountToReturnChange)="amountToReturn = $event"
            data-cy="subscription-seats-refund-payment-mode"
          >
            <ng-template #paymentActions></ng-template>
          </app-payment-mode-form>
        </div>
      </div>
      <ng-container *ngTemplateOutlet="seatsSummaryList"></ng-container>
      <div class="cancel-order-footer">
        <div class="cancel-footer-label">
          <span class="label-bold">{{ seatsNumber || 0 }}</span>
          {{ 'orders.placeSingularPlural' | translate }}
        </div>
        <div class="cancel-footer-label">
          <span>{{ 'shared.payment.totalAmount' | translate }}:</span>
          <span class="label-bold">
            {{ totalAmount$ | async | currency : 'EUR' : 'symbol' : '0.2-2' : 'fr' }}
          </span>
        </div>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #subscriptionRefundSelection let-value="value">
  <div class="subscription-refund-selection">
    <div class="cancel-order-header">
      <h4>{{ 'orders.refundOfFormula' | translate }}</h4>
      <div class="ms-2 label">
        {{ 'orders.orderNumber' | translate }} {{ subscriptionItems?.[0]?.orderId }}
      </div>
    </div>
    <div class="cancel-order-content">
      <ng-container *ngTemplateOutlet="seatRefundCustomer"></ng-container>
      <div class="cancel-order-refund">
        <div class="cancel-folder-refund-header">
          <h5>{{ 'orders.refundMethod' | translate }}</h5>
        </div>
        <div class="cancel-folder-payment-value-inprogress" id="cancel-subscription-payment">
          <app-payment-mode-form
            appendTo="body"
            [formGroup]="form"
            [modes]="paymentModes$ | async"
            [hiddenPaymentTypes]="true"
            [paymentTypes]="paymentTypes"
            [totalAmount]="totalAmount$ | async"
            [clearDefautSelection]="isSubscriptionRefund"
            (amountToReturnChange)="amountToReturn = $event"
            data-cy="subscription-refund-payment-mode"
          >
            <ng-template #paymentActions></ng-template>
          </app-payment-mode-form>
        </div>
      </div>
      <app-summary-list
        [items]="subscriptionItems"
        [title]="'orders.cancelActionInfo.refundOrderItems' | translate"
        [summaryLabelCallback]="getSubscriptionSummaryLabel"
      >
      </app-summary-list>
      <div class="cancel-order-footer">
        <div class="cancel-footer-label">
          <span class="label-bold">{{ seatsNumber || 0 }}</span>
          {{ 'orders.placeSingularPlural' | translate }}
        </div>
        <div class="cancel-footer-label">
          <span>{{ 'shared.payment.totalAmount' | translate }}:</span>
          <span class="label-bold">
            {{ totalAmount$ | async | currency : 'EUR' : 'symbol' : '0.2-2' : 'fr' }}
          </span>
        </div>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #headerTooltip>
  <div class="cancel-order-header-tooltip">
    <mat-icon
      [ngbTooltip]="'orders.info.aRefundWillBeCreatedByFolder' | translate"
      [openDelay]="700"
      tooltipClass="cancel-order-header-ttp"
      [placement]="'auto'"
      container="body"
      [closeDelay]="500"
      >info_outline</mat-icon
    >
  </div>
</ng-template>
<ng-template #seatRefundCustomer>
  <div class="cancel-seat-customer">
    <div class="cancel-order-customer-label">
      <h5>{{ 'orders.customerToBeRefunded' | translate }}</h5>
      <div class="cancel-customer-value">
        <app-customer-dropdown-list
          appendTo="body"
          [data]="customerData"
          [isLoading]="isLoading"
          [selectedId]="selectedCustomerId"
          [allowCustomerCreation]="false"
          [allowCustomerEdit]="false"
          [styleClass]="'ng-select-sm'"
          (searchTrigger)="onSearchTrigger($event)"
          (selectedChange)="onCustomerChange($event)"
          data-cy="seat-refund-customer-dropdown"
        ></app-customer-dropdown-list>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #refundCustomer>
  <div class="cancel-order-customer">
    <div class="cancel-order-customer-label">
      <app-validated-form-row
        [isRemoveHidden]="true"
        [isEditHidden]="isCustomerStepInProgress"
        (edit)="editCustomer()"
        data-cy="customer-to-be-refunded"
      >
        <ng-template #labelTemp>
          <ng-container>
            <h5>{{ 'orders.customerToBeRefunded' | translate }}</h5>
          </ng-container>
        </ng-template>
      </app-validated-form-row>
    </div>
    @if(isCustomerStepInProgress) {
    <div class="cancel-customer-value">
      <app-customer-dropdown-list
        appendTo="body"
        [data]="customerData"
        [isLoading]="isLoading"
        [selectedId]="selectedCustomerId"
        [allowCustomerCreation]="false"
        [allowCustomerEdit]="false"
        [styleClass]="'ng-select-sm'"
        (searchTrigger)="onSearchTrigger($event)"
        (selectedChange)="onCustomerChange($event)"
        data-cy="cancel-order-customer-dropdown"
      ></app-customer-dropdown-list>
    </div>
    }@else {
    <app-validated-form-row [isRemoveHidden]="true" [isEditHidden]="true">
      <ng-template #labelTemp>
        @if(selectedCustomer?.isAnonymous) {
        <span class="ms-1"> {{ 'shared.customer.anonymousCustomer' | translate }} </span>}@else {
        <ng-container
          *ngTemplateOutlet="
            selectedCustomer?.customerType === customerTypeEnum.Moral
              ? moralCustomerForm
              : physicalCustomerForm
          "
        >
        </ng-container
        >}
      </ng-template>
    </app-validated-form-row>
    }
  </div>
</ng-template>
<ng-template #moralCustomerForm>
  <div class="label-item-bold">
    <span>
      {{ selectedCustomer.name }}
    </span>
  </div>
</ng-template>
<ng-template #physicalCustomerForm>
  <div class="label-item-bold">
    @if(selectedCustomer?.isAnonymous) {<span class="ms-1">
      {{ 'shared.customer.anonymousCustomer' | translate }} </span
    >}@else {
    <span> {{ selectedCustomer?.name }} </span>
    }
  </div>
</ng-template>

<ng-template #paymentModeForSingle>
  <div class="cancel-order-refund" id="cancel-order-refund">
    <div class="cancel-folder-refund-header">
      <app-validated-form-row
        [isRemoveHidden]="true"
        [isEditHidden]="isPaymentStepInProgress"
        (edit)="editPaymentMode()"
        data-cy="edit-refund-method"
      >
        <ng-template #labelTemp>
          <ng-container>
            <h5>{{ 'orders.refundMethod' | translate }}</h5>
          </ng-container>
        </ng-template>
      </app-validated-form-row>
    </div>
    @if(isPaymentStepInProgress) {
    <div class="cancel-folder-payment-value-inprogress">
      <app-payment-mode-form
        appendTo="body"
        [formGroup]="form"
        [modes]="paymentModes$ | async"
        [hiddenPaymentTypes]="true"
        [paymentTypes]="paymentTypes"
        [totalAmount]="totalAmount$ | async"
        (amountToReturnChange)="amountToReturn = $event"
        data-cy="folder-cancel-payment-mode"
      >
        <ng-template #paymentActions> </ng-template>
      </app-payment-mode-form>
    </div>
    }@else{ @for (mode of cancelPaymentModes; track $index; let i = $index) {
    <div class="cancel-folder-refund-value">
      <app-validated-form-row
        [isEditHidden]="true"
        [isRemoveHidden]="true"
        [formIndex]="i"
        (edit)="editPaymentMode()"
        data-cy="edit-payment-mode"
      >
        <ng-template #labelTemp>
          <div class="amount-wrapper">
            <span class="label-item-bold">
              {{ mode.paymentTypeLabel }}
            </span>
            <span class="label-item">
              - {{ mode.amount | currency : 'EUR' : 'symbol' : '0.2-2' : 'fr' }}
            </span>
          </div>
        </ng-template>
      </app-validated-form-row>
      @if(i !== cancelPaymentModes?.length - 1) {
      <hr />
      }
    </div>
    } }
  </div>
</ng-template>
<ng-template #paymentModeForSingleEdit>
  <div class="cancel-order-refund">
    <div class="cancel-folder-refund-header">
      <h5>{{ 'orders.refundMethod' | translate }}</h5>
    </div>
    <div class="cancel-folder-payment-value-inprogress" id="cancel-folder-payment">
      <app-payment-mode-form
        appendTo="body"
        [formGroup]="form"
        [modes]="paymentModes$ | async"
        [hiddenPaymentTypes]="true"
        [paymentTypes]="paymentTypes"
        [totalAmount]="totalAmount$ | async"
        (amountToReturnChange)="amountToReturn = $event"
        data-cy="cancel-folder-payment-mode"
      >
        <ng-template #paymentActions> </ng-template>
      </app-payment-mode-form>
    </div>
  </div>
</ng-template>
<ng-template #paymentModeForMultiple>
  <div class="cancel-order-refund">
    <div class="cancel-order-refund-multiple">
      <div class="cancel-order-refund-label">{{ 'orders.info.selectRefundMethod' | translate }}</div>
      <div class="cancel-order-refund-value" id="cancel-order-refund">
        <app-dropdown-list
          appendTo="body"
          [ngModel]="selectedPaymentMode"
          (ngModelChange)="paymentModeChange($event)"
          [items]="paymentModes$ | async"
          placeholder="orders.typeOfPayment"
          bindLabel="name"
          [canSelectMulti]="false"
          [closeOnSelect]="true"
          styleClass="ng-select-sm"
          data-cy="payment-mode-dropdown-multiple-selection"
        >
          <ng-template #customOption let-item="item">
            <div [attr.data-cy]="item?.name">{{ item?.name }}</div>
          </ng-template>
        </app-dropdown-list>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #ordersSummaryList>
  <app-summary-list
    [items]="cancelFolders"
    [title]="'orders.cancelActionInfo.refundOrderItems' | translate"
    [summaryLabelCallback]="getOrderSummaryLabel"
  >
  </app-summary-list>
</ng-template>
<ng-template #seatsSummaryList>
  <app-summary-list
    class="my-2"
    [items]="cancelseats"
    [title]="'orders.cancelActionInfo.refundArticles' | translate"
    [summaryLabelCallback]="getseatSummaryLabel"
  >
  </app-summary-list>
</ng-template>

<ng-template #cancelOrderFooter>
  <div class="cancel-order-footer" id="cancel-order-footer">
    <app-validated-form-row [isRemoveHidden]="true" [isEditHidden]="true">
      <ng-template #labelTemp>
        <ng-container>
          @if(showFooterSummaryItem('folder')) {
          <div class="cancel-footer-label">
            <span class="label-bold">{{ cancelFolders?.length || 0 }}</span>
            {{ 'orders.folders' | translate }}
            {{
              (getOrdersLength() > 1 ? 'orders.ordersCountPlural' : 'orders.ordersCountSingular')
                | translate : { length: getOrdersLength() }
            }}
          </div>
          } @if(showFooterSummaryItem('seat')) {
          <div class="cancel-footer-label">
            <span class="label-bold">{{ seatsNumber || 0 }}</span>
            {{ (seatsNumber > 1 ? 'orders.productPlural' : 'orders.productSinglar') | translate }}
          </div>
          }
          <div class="cancel-footer-label">
            <span>{{ 'shared.payment.totalAmount' | translate }}:</span>
            <span class="label-bold">
              {{ totalAmount$ | async | currency : 'EUR' : 'symbol' : '0.2-2' : 'fr' }}
            </span>
          </div>
        </ng-container>
      </ng-template>
    </app-validated-form-row>
  </div>
</ng-template>
